export const BASE_URL = process.env.REACT_APP_EASYQUANT_API
export const EQ_SECRET = process.env.REACT_APP_EASYQUANT_API_SECRET
